import type { TUserCurrency } from '#shared/types/user.types';

export interface IActiveGameData {
  id: number;
  name: string;
  active: boolean;
  comingSoon: boolean;
  isMultiplayer: boolean;
  unityGame: boolean;
}
export const EFriendStatus = {
  FRIEND: 'friend',
  REJECTED: 'rejected',
  BLOCKED: 'blocked',
  SENT: 'sent',
  RECEIVED: 'received',
  REMOVED: 'removed',
} as const;
export type TFriendStatus = (typeof EFriendStatus)[keyof typeof EFriendStatus];

export interface IFriendData {
  displayName: string;
  friendId: string;
  status: TFriendStatus;
  timestamp: number;
  date?: string;
  online: boolean;
  name?: string;
}

export interface IChallengeData {
  buyIn: number;
  coin: TUserCurrency;
  deleted: boolean;
  displayName: string;
  recordKey: string;
  key: number;
  message: string;
  roomid: string;
  seen: boolean;
  status: string;
  timestamp: number;
  type: string;
  userId: string;
  online: boolean;
}

export const EAlertType = {
  Request: 'REQUEST',
  FriendRequest: 'FRIEND_REQUEST',
  Reward: 'REWARD',
  Challenge: 'CHALLENGE',
  OpenCashier: 'OPEN_VAULT',
  DoAction: 'DO_ACTION',
} as const;
export type TAlertType = (typeof EAlertType)[keyof typeof EAlertType];

export interface IAlertData {
  userId: string;
  displayName: string;
  recordKey: string;
  key: number;
  message: string;
  timestamp: number;
  deleted?: boolean;
  type: TAlertType;
  action?: IAlertAction;
}

export interface IAlertAction {
  type: 'OPEN_MODAL' | 'REDIRECT';
  target: string;
}

export interface IAlertChallengeData extends IAlertData {
  challengeKey: string;
  gameId: number;
  coin: string;
  buyIn: number;
}

export interface IAlertUnityChallengeData extends IAlertChallengeData {
  hostId: string;
}

export interface IAffiliateGlobalConfig {
  affiliatesEarnPercentage: number;
  minAmountTransfer: number;
  minAmountWithdraw: number;
}

export interface IReferralData {}

export interface IGlobalConfig {
  anchorCurrency: string;
  feePaidByUser: boolean;
  maximumRedemptionWithoutKYC: number;
  minimumRedemption: number;
  minusDelta: number;
  plusDelta: number;
}

export interface IPurchaseData {
  creditedMMC: number;
  creditedMQC: number;
  status: string;
  timestamp: number;
  totalMMC: number;
  wageredMMC: number;
  topUp: {
    description: string;
    reason: string;
    topUpBy: string;
  };
}

export interface IOnlineEventData {
  displayName: string;
  isOnline: boolean;
}
